<template>
<div class='vx-col w-full mt-4'>
    <section class="ancho-juego">
        <vs-alert v-if="datos_editar.estado == 0" color="danger">{{ txt_juego_inactivo }} </vs-alert>
        <div class="bg-juego-columnas">
            <vs-row>
                <vs-col vs-w="9" class=" ml-4 mt-3 header-columnas">
                    <div>
                        <h3 class="titulo-juego"> {{ datos_juego.nombre }}</h3>
                        <h5 class="subtitulo-juego"> {{ datos_juego.descripcion }} </h5>
                    </div>
                    <div class="ancho-auto p-2 inline-block">
                        <Voces :datosVoz="datosVoz" />
                    </div>
                    <div class="ancho-auto p-2 inline-block" v-if="conReloj">
                        <Reloj :conReloj="conReloj" :game_fin="game_fin" />
                    </div>
                    <div class="ancho-auto p-2 inline-block">
                        <div class="p-2 code-color-1 redondo font-bold"> Errores: {{ arrayIncorrectas.length }}</div>
                    </div>
                </vs-col>
                <vs-col vs-w="2" class="">
                    <div class="calificacion bg-celeste mt-4 text-color-2">
                        <transition name="bounce">
                            <div v-if="datos_juego.correctas>0">
                                {{datos_juego.correctas.toFixed(2)}} &nbsp;
                            </div>
                            <div v-else> 0 &nbsp; </div>
                        </transition>/ {{ datos_juego.puntaje }}
                    </div>
                </vs-col>
            </vs-row>
            <div class="juego-columnas vx-row mt-4">
                <div class="vx-col w-1/2 ">
                    <div class="p-3" v-for="(item,index) in arrayPreguntas" :key="index">
                        <p @click="f_select_pregunta(item,item.id, $event)" class="hand itemp bg-color1" :id="'p'+item.id"> {{ item.texto }}</p>
                    </div>
                </div>
                <div class="vx-col w-1/2 ">
                    <div class="grupo p-3" v-for="(item,index) in arrayRespuestas" :key="index">
                        <p @click="f_select_respuesta(item,item.id, $event)" class="hand itemr bg-color2" :id="'r'+item.id"> {{ item.texto }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
// import Datos_juegos from '../componentes/datos_juegos.vue';
import Voces from '../componentes/voces.vue';
import Reloj from '../componentes/reloj.vue';
export default {
    components: {
        // Datos_juegos,
        Voces,
        Reloj,
    },
    mixins: [GeneralMixin],
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        },
        juego_seleccionado: {
            type: Object,
            default: function () {
                return {};
            },
        }
    },
    data() {
        return {
            datos_juego: {},
            id_juego: 0,
            arregloOpciones: [],
            arrayPreguntas: [],
            arrayRespuestas: [],
            selectPregunta: {},
            selectRespuesta: {},
            claseAnteriorP: '',
            claseNuevaP: '',
            activeIndexP: null,
            activeIndexR: null,
            activeCorrectoP: false,
            activeCorrectoR: false,
            okPregunta: '',
            okRespuesta: '',
            contP: 0,
            contR: 0,
            arrayCorrectas: [],
            arrayIncorrectas: [],
            correctas: 0,
            datosVoz: {},
            game_fin: false,
            conReloj: false,
            txt_juego_inactivo: 'Juego inactivo - no será visible para el estudiante',
        };
    },
    created() {},
    mounted() {
        let me = this;
        const game_select = Object.keys(me.juego_seleccionado).length == 0
        // console.log('game select', game_select, me.juego_seleccionado)
        if (game_select) {
            this.f_inicio();
        } else {
            me.f_obtener_datos_juego();
        }
    },
    methods: {
        f_obtener_datos_juego() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_juego_by_codigo/' + me.juego_seleccionado.codigo)
                .then(function (response) {
                    // console.log(response.data);
                    me.datos_editar = response.data[0];
                    me.f_inicio();
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se encontró el juego.", "danger");
                    me.$vs.loading.close();
                    // me.$vs.loading.close();
                })
        },
        f_inicio() {
            let me = this;
            me.id_juego = me.datos_editar.id;
            // console.log('datos editar en previsualizar', me.datos_editar, me.id_juego)
            if (me.datos_editar.tiempo == 1) me.conReloj = true;
            me.datos_juego = {
                puntaje: me.datos_editar.puntaje,
                correctas: 0,
                division_puntaje: 0,
                nombre: me.datos_editar.nombre,
                descripcion: me.datos_editar.descripcion
            }
            me.datosVoz = me.datos_editar
            me.f_get_opciones_juego();
        },

        f_get_opciones_juego() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_opciones_emparejar/' + me.id_juego)
                .then(function (response) {
                    // console.log(response.data);
                    me.arregloOpciones = response.data;
                    me.arrayPreguntas = me.arregloOpciones.map(obj => ({
                        id: obj.id,
                        texto: obj.pregunta
                    }));
                    me.arrayRespuestas = me.arregloOpciones.map(obj => ({
                        id: obj.id,
                        texto: obj.respuesta
                    }));
                    me.f_rellenar_datos();
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se logró obtener las respuestas del juego")
                    me.$vs.loading.close();
                });
        },
        f_rellenar_datos() {
            let me = this;
            me.datos_juego.division_puntaje = me.datos_juego.puntaje / me.arrayPreguntas.length
            me.arrayPreguntas.sort(() => (Math.random() > 0.5) ? 1 : -1)
            me.arrayRespuestas.sort(() => (Math.random() > 0.5) ? 1 : -1)
        },
        f_select_pregunta(item, index, event) {
            let me = this;
            if (me.selectPregunta.id != undefined) {
                me.okPregunta.classList.remove('selectedp')
            }
            me.okPregunta = document.getElementById(event.target.id)
            me.okPregunta.classList.add('selectedp')
            me.contP = 1;
            me.selectPregunta = item;
            let verificaCorrecto = event.target.classList.contains('correcto')
            if (!verificaCorrecto) {
                me.checkPair(event.target);
            }
        },
        f_select_respuesta(item, index, event) {
            let me = this;
            if (me.selectRespuesta.id != undefined) {
                me.okRespuesta.classList.remove('selectedr')
            }
            me.okRespuesta = document.getElementById(event.target.id)
            me.okRespuesta.classList.add('selectedr')
            me.contR = 1;
            me.selectRespuesta = item;
            let verificaCorrecto = event.target.classList.contains('correcto')
            if (!verificaCorrecto) {
                me.checkPair(event.target);
            }
        },
        checkPair() {
            let me = this;
            if (me.contP == me.contR) {
                setTimeout(() => {
                    me.selectPregunta = {};
                    me.selectRespuesta = {};
                    me.okPregunta.classList.remove('selectedp')
                    me.okRespuesta.classList.remove('selectedr')
                }, 300)
                me.contP = 0;
                me.contR = 0;
                if (me.selectPregunta.id != me.selectRespuesta.id) {
                    me.arrayIncorrectas.push({
                        idp: me.selectPregunta.id,
                        idr: me.selectRespuesta.id,
                        textoP: me.selectPregunta.texto,
                        textoR: me.selectRespuesta.texto
                    })
                }
            }
            if (me.selectPregunta.id === me.selectRespuesta.id) {
                me.datos_juego.correctas += parseFloat(me.datos_juego.division_puntaje.toFixed(2));
                me.arrayCorrectas.push({
                    idp: me.selectPregunta.id,
                    idr: me.selectRespuesta.id,
                    textoP: me.selectPregunta.texto,
                    textoR: me.selectRespuesta.texto
                })
                me.okPregunta.classList.add('correcto');
                me.okRespuesta.classList.add('correcto');
                me.okPregunta.classList.remove('hand', 'itemp');
                me.okRespuesta.classList.remove('hand', 'itemr');
                if (me.arrayCorrectas.length == me.arrayPreguntas.length) {
                    me.game_fin = true;
                }
            }
            // console.log(me.arrayCorrectas.length, me.arrayIncorrectas.length)
        },

    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Parisienne&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Tilt+Warp&display=swap');

.ancho-juego {
    min-height: 550px;
    max-width: 80%;
    margin: 0 auto;

}

.bg-juego-columnas {
    background-image: url('./assets/bg-columnas.jpg');
    background-repeat: no-repeat;
    /* background-attachment:scroll; */
    /* background-position: bottom; */
    background-size: cover;
}

.header-columnas {
    /* background-color: #e13f09; */
    background: rgb(253, 29, 29);
    background: linear-gradient(90deg, rgba(253, 29, 29, 1) 20%, rgba(242, 231, 110, 0.9626225490196079) 100%);
    text-align: center;
    /* color: white; */
    /* font-family: "Parisienne", cursive; */
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
}

.bg-celeste {
    /* background-color: #00cdfd; */
    background: rgb(21, 204, 245);
    background: linear-gradient(0deg, rgba(21, 204, 245, 1) 0%, rgba(203, 245, 255, 1) 100%);

}

.juego-columnas {
    margin-top: 15px;
}

.titulo-juego {
    /* font-family: "Teko", sans-serif; */
    color: white;
    font-optical-sizing: auto;
    font-weight: 400;
    font-style: normal;
    font-size: 2.5em;
    font-family: "LXGW WenKai Mono TC", monospace;
}

.subtitulo-juego {
    font-family: "LXGW WenKai Mono TC", monospace;
    font-optical-sizing: auto;
    color: white;
}

.bg-juego {
    background-image: url('./assets/bg-juego1.svg');
    background-repeat: no-repeat;
    /* background-attachment:scroll; */
    background-position: bottom;
    background-size: cover;
}

.bg-color1 {
    background-color: #f7f7f7;
}

.bg-color2 {
    background-color: #ededed;
}

.itemp,
.itemr,
.correcto {
    font-weight: bolder;
    border-radius: 10px;
}

.itemp,
.itemr {
    padding: 10px;
    margin: 5px;
    border: 1px solid #ccc;
    transition: background-color 0.3s;
}

.hand {
    cursor: pointer;
}

.itemp:hover {
    /* background-color: lightyellow; */
    background-color: #ffbbbb;
    color: #1f1919;
}

.selectedp {
    background-color: #ffbbbb;
    color: #1f1919;
}

.itemr:hover {
    background-color: rgb(206, 154, 154);
    color: #1f1919;
}

.selectedr {
    background-color: rgb(206, 154, 154);
    color: #1f1919;
}

.correcto {
    background-color: #686666;
    color: white;
    padding: 10px;
    margin: 5px;
    border: 1px solid #ccc;
    /* cursor: pointer; */
    transition: background-color 0.3s;
}

.bg-opciones {
    background-color: #565656;
    border-radius: 0 0 25px 25px;
    /* padding: 2px; */
}

.alto-1 {
    height: 35px;
}

.m-izquierdo {
    margin-left: 20px;
}

.code-color-1 {
    background-color: #dfdcdc;
    color: black;
}

.code-color-2 {
    background-color: #686666;
    color: white;
}

.reloj {
    font-family: "Tilt Warp", sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    font-size: 1em;
    width: 130px;
    text-align: center;
}

@media screen and (max-width: 700px) {
    .ancho-juego {
        min-height: 650px;
        min-width: 500px;
        margin: 0 auto;

    }

    .bg-juego-columnas {
        background-image: url('./assets/bg-columnas.jpg');
        background-repeat: no-repeat;
        /* background-attachment:scroll; */
        /* background-position: bottom; */
        background-size: cover;
    }
}
</style>
